export default __webpack_public_path__ + "static/media/4.7c55c797.png";